import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "@/components/auth/AuthLayout";
import RoleSelectionGrid from "@/components/auth/RoleSelectionGrid";
import GoogleSignInButton from "@/components/auth/GoogleSignInButton";
import ParentSignupForm from "@/components/auth/ParentSignupForm";
import DoctorSignupForm from "@/components/auth/DoctorSignupForm";
import SchoolSignupForm from "@/components/auth/SchoolSignupForm";
import ClassTeacherSignupForm from "@/components/auth/ClassTeacherSignupForm";

export default function SignupPage() {
  const [role, setRole] = useState(null);

  const renderForm = () => {
    switch (role) {
      case "parent": return <ParentSignupForm />;
      case "doctor": return <DoctorSignupForm />;
      case "school": return <SchoolSignupForm />;
      case "class_teacher": return <ClassTeacherSignupForm />;
      default: return null;
    }
  };

  return (
    <AuthLayout
      title={role ? "Complete your profile" : "Create your tots360 account"}
      subtitle={
        role
          ? "Fill in the details below to activate your account."
          : "First, tell us who you are."
      }
      sideTitle="Every child deserves a 360° health story."
      sideBullets={[
        "Free for parents — unlimited reports for your children",
        "Schools can brand reports with their own logo",
        "Doctors can review every case with longitudinal data",
        "Verified emails and consent logs protect every record",
      ]}
    >
      {!role ? (
        <div className="space-y-6">
          <RoleSelectionGrid value={role} onChange={setRole} />

          <div className="flex items-center gap-3">
            <span className="flex-1 h-px bg-slate-700" />
            <span className="text-xs text-slate-500">OR</span>
            <span className="flex-1 h-px bg-slate-700" />
          </div>

          <GoogleSignInButton label="Sign up with Google" returnTo="/dashboard" />
          <p className="text-xs text-slate-500 text-center">
            Signing up with Google? You'll be asked to choose your role next.
          </p>

          <p className="mt-8 text-sm text-slate-400 text-center">
            Already have an account?{" "}
            <Link to="/login" className="text-sky-400 hover:text-sky-300 font-medium" data-testid="signup-to-login-link">
              Sign in
            </Link>
          </p>
        </div>
      ) : (
        <div>
          <button
            type="button"
            onClick={() => setRole(null)}
            data-testid="signup-change-role-button"
            className="text-xs text-slate-400 hover:text-slate-200 mb-4 inline-flex items-center gap-1"
          >
            ← Change role
          </button>
          {renderForm()}
        </div>
      )}
    </AuthLayout>
  );
}
